<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="600px" @keydown="checkEsc">
      <v-card>
        <v-card-title class="flex-nowrap">
          <v-btn icon small @click="settingsDialog = true" class="tiny-button">
            <i class="material-icons">settings</i>
          </v-btn>
          <v-btn icon middle @click="prevMonth()" class="tiny-button">
            <i class="v-icon material-icons">arrow_left</i>
          </v-btn>
          <span class="card-header"
            >{{ $t('userCard.startDateLabel') }} {{ startDate }}
            {{ $t('userCard.endDateLabel') }} {{ endDate }}</span
          >
          <v-btn icon middle @click="nextMonth()" class="tiny-button">
            <i class="v-icon material-icons">arrow_right</i>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="Absolute-Center" v-if="!usrData && !usrDataIsLoaded">
            <spinner></spinner>
          </div>
          <div v-if="!usrData && !monthCount && usrDataIsLoaded">
            <h3 class="text-center">{{ $t('userCard.noDataError') }}</h3>
          </div>
          <div class="Absolute-Center" v-if="usrData || monthCount">
            <h3 class="align-center">{{ userName }}</h3>
            <h5 class="align-center">
              {{ $t('userCard.workingOutPerMonth') }} : {{ monthCount }} н/ч,
              {{ monthSum }} грн.
            </h5>
            <h5 class="align-center">
              * {{ $t('userCard.dataCompositionWarning') }}
            </h5>
            <div class="accordion-row title-txt-holder">
              <div
                v-bind:class="
                  showFactColumns ? 'title-name' : 'title-name-without-fact'
                "
              >
                <h5>{{ $t('userCard.dateDocTitle') }}</h5>
              </div>
              <div
                v-bind:class="
                  showFactColumns ? 'value-name' : 'value-name-without-fact'
                "
              >
                <h5>{{ $t('userCard.timesheetTitle') }}</h5>
              </div>
              <div
                v-if="showFactColumns"
                v-bind:class="
                  showFactColumns ? 'value-name' : 'value-name-without-fact'
                "
              >
                <h5>{{ $t('userCard.factByDocumentsTitle') }}</h5>
              </div>
              <div
                v-if="showFactColumns"
                v-bind:class="
                  showFactColumns ? 'value-name' : 'value-name-without-fact'
                "
              >
                <h5>{{ $t('userCard.factByWorksTitle') }}</h5>
              </div>
            </div>
            <div v-for="(day, index) in usrData" :key="index">
              <div
                @click="setCurrentDay(day.date)"
                class="accordion-row"
                v-bind:class="{
                  'active-row': currentDay === day.date,
                }"
              >
                <div class="row-avatar">
                  <v-avatar v-if="!day.documents" size="25px" tile>
                    <i aria-hidden="true" class="v-icon material-icons"
                      >highlight_off</i
                    >
                  </v-avatar>
                  <v-avatar
                    v-if="currentDay !== day.date && day.documents"
                    size="25px"
                    tile
                  >
                    <i aria-hidden="true" class="v-icon material-icons">add</i>
                  </v-avatar>
                  <v-avatar
                    v-if="currentDay === day.date && day.documents"
                    size="25px"
                    tile
                  >
                    <i aria-hidden="true" class="v-icon material-icons"
                      >remove</i
                    >
                  </v-avatar>
                </div>
                <div class="date-txt-holder">
                  <div
                    v-bind:class="
                      showFactColumns ? 'row-name' : 'row-name-without-fact'
                    "
                  >
                    <h5>{{ day.date }}</h5>
                  </div>
                  <div
                    v-bind:class="
                      showFactColumns ? 'row-value' : 'row-value-without-fact'
                    "
                  >
                    <h5>{{ day.count }}</h5>
                    <h6>{{ day.sum }}</h6>
                  </div>
                  <div
                    v-if="showFactColumns"
                    v-bind:class="
                      showFactColumns ? 'row-value' : 'row-value-without-fact'
                    "
                  >
                    <h5>{{ day.productivity }}</h5>
                  </div>
                  <div
                    v-if="showFactColumns"
                    v-bind:class="
                      showFactColumns ? 'row-value' : 'row-value-without-fact'
                    "
                  >
                    <h5>{{ day.productivityByWork }}</h5>
                  </div>
                </div>
              </div>
              <div v-if="currentDay === day.date">
                <div v-for="(item, index) in day.documents" :key="index">
                  <div
                    @click="setCurrentDoc(item.docId)"
                    class="accordion-row car-row"
                    v-bind:class="{
                      'active-row': currentDoc === item.docId,
                    }"
                  >
                    <div class="row-avatar">
                      <v-avatar v-if="!item.details" size="25px" tile>
                        <i aria-hidden="true" class="v-icon material-icons"
                          >highlight_off</i
                        >
                      </v-avatar>
                      <v-avatar
                        v-if="currentDoc !== item.docId && item.details"
                        size="25px"
                        tile
                      >
                        <i aria-hidden="true" class="v-icon material-icons"
                          >add</i
                        >
                      </v-avatar>
                      <v-avatar
                        v-if="currentDoc === item.docId && item.details"
                        size="25px"
                        tile
                      >
                        <i aria-hidden="true" class="v-icon material-icons"
                          >remove</i
                        >
                      </v-avatar>
                    </div>
                    <div class="auto-txt-holder car-holder">
                      <div
                        v-bind:class="
                          showFactColumns ? 'row-name' : 'row-name-without-fact'
                        "
                      >
                        <h5>{{ item.carName }}</h5>
                      </div>
                      <div
                        v-bind:class="
                          showFactColumns
                            ? 'row-value'
                            : 'row-value-without-fact'
                        "
                      >
                        <h5>{{ item.count }}</h5>
                        <h6>{{ item.sum }}</h6>
                      </div>
                      <div
                        v-if="showFactColumns"
                        v-bind:class="
                          showFactColumns
                            ? 'row-value'
                            : 'row-value-without-fact'
                        "
                      >
                        <h5>{{ item.productivity }}</h5>
                      </div>
                      <div
                        v-if="showFactColumns"
                        v-bind:class="
                          showFactColumns
                            ? 'row-value'
                            : 'row-value-without-fact'
                        "
                      >
                        <h5>{{ item.productivityByWork }}</h5>
                      </div>
                    </div>
                  </div>
                  <div v-if="currentDoc === item.docId">
                    <div v-for="(itemWork, index) in item.details" :key="index">
                      <div class="accordion-row">
                        <div class="row-avatar">
                          <v-avatar size="25px" tile>
                            <i aria-hidden="true" class="v-icon material-icons"
                              >miscellaneous_services</i
                            >
                          </v-avatar>
                        </div>
                        <div class="auto-txt-holder work-holder">
                          <div
                            v-bind:class="
                              showFactColumns
                                ? 'row-name'
                                : 'row-name-without-fact'
                            "
                          >
                            <h5>{{ itemWork.work }}</h5>
                          </div>
                          <div
                            v-bind:class="
                              showFactColumns
                                ? 'row-value'
                                : 'row-value-without-fact'
                            "
                          >
                            <h5>{{ itemWork.count }}</h5>
                            <h6>{{ itemWork.sum }}</h6>
                          </div>
                          <div
                            v-if="showFactColumns"
                            v-bind:class="
                              showFactColumns
                                ? 'row-value'
                                : 'row-value-without-fact'
                            "
                          >
                            <h5>-</h5>
                          </div>
                          <div
                            v-if="showFactColumns"
                            v-bind:class="
                              showFactColumns
                                ? 'row-value'
                                : 'row-value-without-fact'
                            "
                          >
                            <h5>{{ itemWork.productivityByWork }}</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="salary" v-if="salary">
            <v-spacer></v-spacer>
            <h5>
              {{ $t('userCard.accruedSalary') }}: {{ salary.accrued }}
              {{ $t('userCard.salaryPaid') }}: {{ salary.paid }}
            </h5>
            <v-spacer></v-spacer>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeForm()">{{ $t('global.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="settingsDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('global.settings') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list class="elevation-1">
            <v-checkbox
              :label="userCardTexts.showFactColumns"
              v-model="showFactColumns"
            ></v-checkbox>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="settingsDialog = false">
            {{ $t('global.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from '@/services/axios'
import i18n from '@/plugins/i18n'
import store from '@/services/store'

export default {
  name: 'userCard',
  data: () => ({
    dialog: false,
    usrData: undefined,
    salary: undefined,
    usrDataIsLoaded: false,
    showFactColumns: false,
    settingsDialog: false,
    month: 0,
    monthCount: 0,
    monthSum: 0,
    dayCount: 0,
    daySum: 0,
    userName: '',
    userPosition: '',
    currentDoc: '',
    currentDay: '',
    startDate: '-',
    endDate: '-',
    worksHeaders: [
      {
        colId: 'usercardColumnWork',
        text: 'Работа',
        value: 'rowName',
        align: 'left',
      },
      {
        colId: 'usercardColumnWorkingOut',
        text: 'Выработка',
        value: 'startTime',
        align: 'center',
        class: 'table-col-small',
      },
      {
        colId: 'usercardColumnFact',
        text: 'Факт',
        value: 'endTime',
        align: 'center',
        class: 'table-col-small',
      },
    ],
  }),
  components: {
    spinner: () => import('./Spinner.vue'),
  },
  created() {
    this.refreshListOptions()
  },
  computed: {
    globalTexts: function() {
      return i18n.messages[i18n.locale].global
    },
    userCardTexts: function() {
      return i18n.messages[i18n.locale].userCard
    },
  },
  watch: {
    showFactColumns() {
      if (this.showFactColumns != store.state.showFactColumns) {
        this.showFactColumnsOnChange()
      }
    },
  },
  methods: {
    refreshListOptions() {
      this.worksHeaders.forEach(element => {
        element.text = this.userCardTexts[element.colId]
      })
    },
    show() {
      this.$nextTick(() => {
        this.dialog = true
        this.inputFocus()
        this.getUserCard()
        this.initParams()
      })
    },
    closeForm() {
      this.usrData = undefined
      this.dialog = false
      this.month = 0
    },
    checkEsc(ev) {
      if (ev.keyCode === 27) {
        this.dialog = false
      }
    },
    setCurrentDoc(docId) {
      this.currentDoc === docId
        ? (this.currentDoc = '')
        : (this.currentDoc = docId)
    },
    setCurrentDay(day) {
      this.currentDay === day ? (this.currentDay = '') : (this.currentDay = day)
    },
    inputFocus() {
      const inputHolder = this.$refs.inputHolder
      if (inputHolder) {
        const input = inputHolder.querySelector('input')
        if (input) {
          this.$nextTick(() => input.focus())
        }
      }
    },
    prevMonth() {
      this.month = this.month - 1
      this.getUserCard()
    },
    nextMonth() {
      this.month = this.month + 1
      this.getUserCard()
    },
    getUserCard() {
      this.usrDataIsLoaded = false
      this.monthCount = 0
      this.monthSum = 0
      this.usrData = undefined
      this.salary = undefined
      axios
        .request({
          url: '/UserCard',
          params: {
            month: this.month,
          },
        })
        .then(resp => {
          this.usrDataIsLoaded = true
          this.userName = resp.data.userCard.userName
          this.userPosition = resp.data.userCard.userPosition
          if (this.userPosition === '') {
            this.userPosition = 'Механик'
          }
          this.monthCount = resp.data.userCard.monthCount
          this.monthSum = resp.data.userCard.monthSum
          this.dayCount = resp.data.userCard.dayCount
          this.daySum = resp.data.userCard.daySum
          this.startDate = resp.data.userCard.startDate
          this.endDate = resp.data.userCard.endDate
          this.usrData = resp.data.userCard.data
          if (resp.data.salary) {
            this.salary = resp.data.salary
          }
        })
    },
    initParams() {
      this.showFactColumns = store.state.showFactColumns
    },
    showFactColumnsOnChange() {
      store.dispatch('updateShowFactColumns', this.showFactColumns)
    },
  },
}
</script>
<style scoped lang="scss">
@import '../_scss/mixins';
@import '../_scss/breakpoints';

.card-header {
  @include xs {
    padding-left: 0;
    padding-right: 0;
  }
}

.blink-area {
  -webkit-animation: blink 1s linear infinite;
  animation: blink 1s linear infinite;
  width: 10px;
  height: 10px;
  margin: 3px 10px 10px 10px;
}

@-webkit-keyframes blink {
  0% {
    background: rgb(192, 22, 22);
  }
  100% {
    background: rgba(192, 22, 22, 0.2);
  }
}

@keyframes blink {
  0% {
    background: rgb(192, 22, 22);
  }
  100% {
    background: rgba(192, 22, 22, 0.2);
  }
}

/deep/.v-dialog {
  margin: 0;
}

/deep/.v-card__title {
  padding-bottom: 0;
}

h3 {
  font-size: 16px;
}

h5 {
  font-size: 14px;
}

.card-header {
  font-size: 16px;
  @include xs {
    font-size: 12px;
  }
}

.status-row {
  margin: 0;
}

.accordion-row {
  margin-top: 5px;
  display: flex;
  width: 100%;
  @include xs {
    margin-top: 2px;
  }
}

.accordion-row:hover {
  text-decoration: none;
  background: rgb(102, 80, 80);
}

.accordion-row h5 {
  margin: 0;
  font-size: 12px;
  @include xs {
    font-size: 9px;
  }
}

.accordion-row h6 {
  margin-top: 5px;
  font-size: 10px;
  @include xs {
    font-size: 9px;
  }
}

.active-row {
  display: flex;
  background: rgb(102, 80, 80);
}

.title-txt-holder {
  width: 100%;
  display: flex;
  padding-left: 35px;
}

.date-txt-holder {
  width: 100%;
  display: flex;
}

.row-avatar {
  width: 35px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  .v-icon {
    @include xs {
      font-size: 18px;
    }
  }
}

.auto-txt-holder {
  padding-bottom: 10px;
  padding-left: 5px;
  display: flex;
  width: 100%;
}

.work-holder {
  padding-left: 10px;
  .row-name,
  .row-name-without-fact,
  .row-value-without-fact,
  .row-value {
    border: none;
    border-bottom: 1px dashed;
  }
}

.car-row {
  margin-top: 0;
  .row-name,
  .row-name-without-fact,
  .row-value-without-fact,
  .row-value {
    border: none;
  }
  .car-holder {
    padding: 0;
  }
}

.data-table-holder {
  border-width: 1px;
  padding: 5px 5px;
  border-style: dotted;
  border-color: coral;
}

.title-name,
.title-name-without-fact,
.value-name-without-fact,
.value-name {
  border-width: 1px;
  padding: 5px 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-style: dotted;
  border-color: coral;
  text-align: center;
  @include xs {
    padding: 1px 1px;
  }
}

.title-name {
  width: 55%;
}

.title-name-without-fact {
  width: 80%;
}

.value-name {
  width: 15%;
}

.value-name-without-fact {
  width: 20%;
}

.row-name,
.row-name-without-fact,
.row-value-without-fact,
.row-value {
  border-width: 1px;
  padding: 5px 5px;
  @include xs {
    padding: 1px 1px;
  }
  border-style: dotted;
  border-color: coral;
}

.row-name {
  text-align: left;
  width: 55%;
}

.row-name-without-fact {
  text-align: left;
  width: 80%;
}

.row-value {
  text-align: center;
  width: 15%;
}

.row-value-without-fact {
  text-align: center;
  width: 20%;
}

.active-work-row {
  background: rgb(91, 163, 82) !important;
}

.tiny-button {
  margin: 2px 6px;
}

.salary {
  margin-top: 10px;
  display: flex;
}
</style>
